import React, { Component } from 'react';
import { withRouter } from "react-router";
import AppContext from '../../AppContext'

import Checkbox from '@mui/material/Checkbox';

import { withTranslation } from 'react-i18next';

import styles from '../../styles/products.module.css'; 


class Terms extends Component {
  
    constructor(props) {
        super(props)
        
        this.state = {
            audio: "audiofile.mp3",
            checked: false
        }

    }

    static contextType = AppContext
    
    componentDidMount() {

        
    }


    async handleChange(e) {

        const { setTerms, acceptedTerms } = this.context;

        if(!acceptedTerms) {
            await setTerms(true)
        } else {
            await setTerms(false)
        }
        await console.log(e.target.checked)
        await this.props.action(e.target.checked);
    }

    render() {

    const { acceptedTerms } = this.context;

    const checkedState = acceptedTerms;
    const { t } = this.props;

    return (
        <div style={{display: 'flex', marginTop: '30px', fontFamily: 'Bosch-Medium', fontSize: '14px'}}>
            <div>
                <Checkbox
                checked={checkedState}
                onChange={(e) => { this.handleChange(e)}}
                inputProps={{ 'aria-label': 'controlled' }}
                sx={{
                    color: '#008ECF',
                    '&.MuiCheckbox-root': { padding: 0 },
                    '&.MuiSvgIcon-root': { fontSize: 20 },
                    '&.Mui-checked': {
                    color: '#008ECF',
                    },
                }}
                />
            </div>
            <div className={styles.termsText} dangerouslySetInnerHTML={
                {__html: t('terms.text', {interpolation: {escapeValue: false}})}
            } />
            
        </div>

    );
  }
}

export default withRouter(withTranslation()(Terms));